import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { Modal } from 'components/Modal'
import Button from 'components/Button'
import Divider from 'components/Divider'
// Temporary solution
import themeStyle from 'config/theme'

import { StyledServiceModalContent, StyledServiceBtnContainer } from '../styled/service'

const ServiceModal = ({ type = 'confirm', onOk, onCancel, width = 450, height, onClose, label, text, btnText, btnCancelText, children, render }) => {
	const [t] = useTranslation()
	const isConfirm = type === 'confirm'

	useEffect(() =>{
		window.addEventListener('keyup', handleKeyUp)
		return () => {
			window.removeEventListener('keyup', handleKeyUp)
		}
	}, [])

	const handleKeyUp = ({ key }) => {
		if(key === 'Enter') {
			onOk()
		} else if (key === 'Escape') {
			onClose()
		}
	}

	return(
		<Modal label={label ?? t('common.strings.information')} width={width} height={height} unmount={onClose}>
			<StyledServiceModalContent>
				<div>{text}</div>
				<Divider />
				{children}
				{typeof render === 'function' ? render() : null}
				<StyledServiceBtnContainer>
					{isConfirm &&
                    <Button theme={themeStyle} shrink status='cancelation' text={btnCancelText ?? t('common.buttons.abort')} onClick={onCancel || onClose} />}
					<Button theme={themeStyle} shrink status='primary' text={btnText ?? t('common.buttons.submit')} onClick={onOk || onClose} />
				</StyledServiceBtnContainer>
			</StyledServiceModalContent>
		</Modal>
	)
}

ServiceModal.propTypes = {
	type: PropTypes.oneOf(['warning', 'confirm']),
	onClose: PropTypes.func.isRequired,
	onOk: PropTypes.func,
	onCancel: PropTypes.func,
	label: PropTypes.string,
	text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	btnText: PropTypes.string,
	btnCancelText: PropTypes.string,
	width: PropTypes.number
}

export default ServiceModal
